import { gql } from "@apollo/client";

export const createCheckinTemplate = gql`
  mutation createCheckinTemplate($input: createTargetMutationInput!) {
    createTargetMutation_New(input: $input) {
      id
      assignCheckInsToTarget {
        targetCheckins {
          multimediaCheckin {
            fileType
            s3Link {
              fileName
              url
              uploadUrl
              key
              region
              isNew
              bucket
            }
            isVideoUrl
          }
          eventCheckin {
            documents {
              fileName
              url
              uploadUrl
              key
              region
              isNew
              bucket
            }
          }
        }
      }
    }
  }
`;
